module.exports = __webpack_public_path__ + "img/Restaurant8.b5520c20.png";